const headerStyle = {
  height: '64px',
};

export default headerStyle;
